module.exports = __webpack_public_path__ + "img/16m007-07.4d01e2f0.png";